import e from "react";
import r from "prop-types";
import { P as o } from "./context-B284KgoM.es.js";
import './TextInputSelect.css';const n = "TextInputSelect-module__container___X--Hc", c = {
  container: n
}, a = (t) => /* @__PURE__ */ e.createElement(o, { value: !0 }, /* @__PURE__ */ e.createElement("div", { className: c.container }, t.children));
a.propTypes = {
  /** the TextInput and Select components to be passed in */
  children: r.node.isRequired
};
export {
  a as T
};
